import * as React from 'react';

function SvgImage(props) {
  return (
    <svg viewBox="0 0 42 34" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M40.5.5h-39C.67.5 0 1.17 0 2v30c0 .83.67 1.5 1.5 1.5h39c.83 0 1.5-.67 1.5-1.5V2c0-.83-.67-1.5-1.5-1.5zm-1.875 29.625H3.375v-1.87l6.492-7.702 7.036 8.344 10.945-12.975L38.625 28.7v1.425zm0-6.084L28.135 11.6a.373.373 0 00-.573 0L16.904 24.238l-6.75-8.002a.373.373 0 00-.572 0l-6.206 7.36V3.874h35.25V24.04zM11.25 14.375a4.125 4.125 0 100-8.25 4.125 4.125 0 000 8.25zm0-5.438a1.31 1.31 0 011.313 1.313 1.31 1.31 0 01-1.313 1.313 1.31 1.31 0 01-1.313-1.313 1.31 1.31 0 011.313-1.313z" />
    </svg>
  );
}

export default SvgImage;
